import React from 'react';

import { routes } from '@aline/routes';
import { Helmet } from 'react-helmet';
import { Route, Routes } from 'react-router-dom';
import { ContentWrapper, Party, PartyList } from 'src/components';
import { createRelativeRouter } from 'src/helpers/router-helpers';

const { toRelativePath: toRelativePartiesPath } = createRelativeRouter(routes.PartyIndex, {
  nestedRoutes: true,
});

export function Parties(): JSX.Element {
  return (
    <>
      <Helmet>
        <title>Parties</title>
      </Helmet>
      <ContentWrapper>
        <Routes>
          <Route element={<PartyList />} path={toRelativePartiesPath(routes.PartyIndex)} />
          <Route element={<Party />} path={toRelativePartiesPath(routes.PartyDetailIndex)} />
        </Routes>
      </ContentWrapper>
    </>
  );
}
